import { components } from 'react-select'

// Custom Option to show a checkmark
export const CustomOption = (props: any) => {
  return (
    <components.Option {...props}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          color: props.isDisabled ? '#aaa9a9' : 'black',
          fontWeight: props.isSelected ? 'bold' : 'normal',
        }}
      >
        {props.label}
        {props.isSelected && <span>✓</span>}
      </div>
    </components.Option>
  )
}
